import { Navigate, NavLink, useParams } from "react-router-dom";
import { SettingsLayout, SettingsNav, SettingsNavItem } from "@/components/ui/settings-layout";
import { SETTINGS_CATEGORIES as CATEGORIES } from "@/constants/settings-categories";
import {
  BrandSetupSection,
  PersonalSection,
  DataSection,
  OrganizationSection,
  ExclusionListSection,
  SavedFieldsSection,
  IntegrationsSection,
} from "./sections";

export default function SettingsPage() {
  const { category = "brand-setup" } = useParams<{ category: string }>();

  // A removed or mistyped category (old /settings/appearance links) lands on the first page.
  if (!CATEGORIES.some((c) => c.key === category)) {
    return <Navigate to="/dashboard/settings/brand-setup" replace />;
  }

  return (
    <SettingsLayout
      sectionKey={category}
      nav={
        <SettingsNav>
          {CATEGORIES.map((c) => (
            <SettingsNavItem key={c.key} asChild active={category === c.key}>
              <NavLink to={`/dashboard/settings/${c.key}`}>
                <c.icon />
                {c.label}
              </NavLink>
            </SettingsNavItem>
          ))}
        </SettingsNav>
      }
    >
      {category === "brand-setup" && <BrandSetupSection />}
      {category === "personal" && <PersonalSection />}
      {category === "data" && <DataSection />}
      {category === "organization" && <OrganizationSection />}
      {category === "integrations" && <IntegrationsSection />}
      {category === "exclusion-list" && <ExclusionListSection />}
      {category === "saved-fields" && <SavedFieldsSection />}
    </SettingsLayout>
  );
}
